<template>
  <div>
    <TabHeaderFilter
      :placeholder="placeholder"
      :filter="filter"
      @exportExcel="exportExcel"
      @sidebarFilter="sidebarFilter"
      @handleSearch="handleSearch"
    />
    <TableCustomerUseCoupon
      :fields="fields"
      :items="items"
      :isBusy="isBusy"
      :filter="filter"
      :rows="rows"
      :pageOptions="pageOptions"
      :showing="showing"
      :showingTo="showingTo"
      @getPage="getPage"
      @getPageOption="getPageOption"
    />
  </div>
</template>

<script>
import TabHeaderFilter from "@/components/coupon/detail/customer/TabHeaderFilter";
import TableCustomerUseCoupon from "@/components/coupon/detail/customer/TableCustomerUseCoupon";
export default {
  components: {
    TabHeaderFilter,
    TableCustomerUseCoupon,
  },
  props: {
    filter: {
      required: true,
      type: Object,
    },
    fields: {
      required: true,
      type: Array,
    },
    items: {
      required: true,
      type: Array,
    },
    isBusy: {
      required: true,
      type: Boolean,
    },
    rows: {
      required: true,
      type: Number,
    },
    pageOptions: {
      required: true,
      type: Array,
    },
    showing:{
      required: true,
      type: Number
    },
    showingTo:{
      required: true,
      type: Number
    },
    placeholder:{
      required:false,
      type:String
    }
  },
  methods:{
    exportExcel(){
      this.$emit("exportExcel");
    },
    getPage(value){
      this.$emit("getPage",value);
    },
    getPageOption(value){
      this.$emit("getPageOption",value);
    },
    sidebarFilter(){
      this.$emit("sidebarFilter");
    },
    handleSearch(value){
      this.$emit("handleSearch",value);
    },
  }
};
</script>

<style lanng="scss" scoped>
</style>
